module.exports = __webpack_public_path__ + "img/cancel.41b343d3.svg";